import React, { useEffect, useState } from 'react';
import { getCustomerSettingsDetails } from "../../../api/endpoints/customer";
import { showDeleteAlert } from "../../../utils/swalAlerts/showDeleteAlert";
import showSuccessAlert from '../../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../../utils/swalAlerts/showErrorAlert';
import { updateCustomerSettings }  from '../../../api/endpoints/customer';

const CustomerSettingFormModal = ({ show, onClose, onSave, compId, customerId }) => {
  const [validated, setValidated] = useState(false);
  const [form, setForm] = useState({
    text_msg : 1,
    image_msg : 1,
    audio_msg : 1,
    video_msg : 1,
    docs_msg : 1,
  })

  useEffect(() => {
      const fetchData = async () => {
        if(show){

          console.log(customerId);
          const response = await getCustomerSettingsDetails(compId, customerId);
          console.log(response);
          if(response.status === 200){
            const settingData = response.data.data;
            setForm({
              text_msg : settingData.text,
              image_msg : settingData.image,
              audio_msg : settingData.audio,
              video_msg : settingData.video,
              docs_msg : settingData.document,
            });
          }          
        }
      };
      fetchData();
     },[customerId, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log((/^[1-9]$/.test(value)));
    if (/^[1-9]?$/.test(value)) {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;

    if (formElement.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    // add confirmation dialog box
    console.log(form);
    onSave(form);
    showDeleteAlert({
      title: 'Are you sure you want to change these settings?',
      message: '',
      confirmButtonText: 'Yes!',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await updateCustomerSettings(compId, customerId, form);
          if(response.status === 200){
            // send sucess 
            if(response.data.success){
              showSuccessAlert({
                title: "Settings for customer",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
              })
              onClose();
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  };

  return (
    <div className={`modal fade ${show ? "show d-block" : ""}`} id="customerSettingModal" tabindex="-1" aria-labelledby="customerSettingModalLabel" aria-modal="true">
        <div className="modal-dialog">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="customerSettingModalgridLabel">Customer Credit Settings</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit} 
                      className={`tablelist-form needs-validation ${validated ? "was-validated" : ""}`}
                      noValidate
					            autoComplete="off">
                        <div className="row g-3">
                            <div className="col-xxl-6">
                              <div>
                                <label for="txt" className="form-label">Credit utilized for text whats app</label>
                                <input 
                                  type="text" 
                                  className="form-control" 
                                  name="text_msg" 
                                  value={form.text_msg} 
                                  onChange={handleChange} 
                                  inputMode="numeric" 
                                  pattern="[1-9]{1}" 
                                  placeholder="1-9" 
                                  maxLength={1} 
                                  required/>
                              </div>
                            </div>
                            <div className="col-xxl-6">
                              <div>
                                <label for="img" className="form-label">Credit utilized for image whats app</label>
                                <input 
                                  type="text" 
                                  className="form-control" 
                                  name="image_msg" 
                                  value={form.image_msg} 
                                  onChange={handleChange} 
                                  inputMode="numeric" 
                                  pattern="[1-9]{1}" 
                                  placeholder="1-9" 
                                  maxLength={1} 
                                  required />
                              </div>
                            </div>
                            <div className="col-xxl-6">
                              <div>
                                <label for="audio" className="form-label">Credit utilized for audio whats app</label>
                                <input 
                                  type="text" 
                                  className="form-control" 
                                  name="audio_msg" 
                                  value={form.audio_msg} 
                                  onChange={handleChange} 
                                  inputMode="numeric" 
                                  pattern="[1-9]{1}" 
                                  placeholder="1-9" 
                                  maxLength={1}  
                                  required/>
                              </div>
                            </div>
                            <div className="col-xxl-6">
                              <div>
                                <label for="video" className="form-label">Credit utilized for video whats app</label>
                                <input 
                                  type="text" 
                                  className="form-control" 
                                  name="video_msg" 
                                  value={form.video_msg} 
                                  onChange={handleChange} 
                                  inputMode="numeric" 
                                  pattern="[1-9]{1}" 
                                  placeholder="1-9" 
                                  maxLength={1}  
                                  required/>
                              </div>
                            </div>
                            <div className="col-xxl-6">
                              <div>
                                <label for="viddocseo" className="form-label">Credit utilized for document whats app</label>
                                <input 
                                  type="text" 
                                  className="form-control" 
                                  name="docs_msg" 
                                  value={form.docs_msg} 
                                  onChange={handleChange} 
                                  inputMode="numeric" 
                                  pattern="[1-9]{1}" 
                                  placeholder="1-9" 
                                  maxLength={1}  
                                  required/>
                              </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="hstack gap-2 justify-content-end">
                                    <button type="button" className="btn btn-light" data-bs-dismiss="modal"  onClick={onClose}>Close</button>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CustomerSettingFormModal